module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/102.6cb7a332.png";